const courseRoutes = [
  {
    path: '/course/category',
    name: 'course-category-list',
    component: () => import('@/views/course/course-category-list')
  },
  {
    path: '/course/category/:categoryId/list',
    name: 'course-list',
    component: () => import('@/views/course/course-list')
  },
  {
    path: '/course/category/course/video',
    name: 'course-video',
    component: () => import('@/views/course/course-video-view')
  }
]

export default courseRoutes
